import { render, staticRenderFns } from "./addBourse.vue?vue&type=template&id=cc7383da&scoped=true&"
import script from "./addBourse.vue?vue&type=script&lang=js&"
export * from "./addBourse.vue?vue&type=script&lang=js&"
import style0 from "./addBourse.vue?vue&type=style&index=0&id=cc7383da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc7383da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc7383da')) {
      api.createRecord('cc7383da', component.options)
    } else {
      api.reload('cc7383da', component.options)
    }
    module.hot.accept("./addBourse.vue?vue&type=template&id=cc7383da&scoped=true&", function () {
      api.rerender('cc7383da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/currency/bourse/components/addBourse.vue"
export default component.exports